import { Component, TemplateRef, ViewChild, EventEmitter, Output, QueryList, ElementRef, ContentChildren, AfterContentInit, ViewContainerRef, Self, Optional, SkipSelf } from '@angular/core';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { MenuService } from './menu.service';
import { height, opacity } from '../../animations/animations';

@Component({
    selector: 'menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    exportAs: 'menu',
    animations: [
        opacity('100ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)'),
        height('100ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)')
    ],
    providers: [
        MenuService
    ],
    standalone: false
})
export class MenuComponent implements AfterContentInit {
    @ViewChild(TemplateRef, { static: true })
    public _template: TemplateRef<any>;
    @ContentChildren(MenuItemComponent)
    public _items: QueryList<MenuItemComponent>;

    @Output() items: QueryList<MenuItemComponent>;
    @Output() closed: boolean = true;
    @Output() onClosing = new EventEmitter<void>();
    @Output() onOpening = new EventEmitter<void>();
    get template() { return this._template; }

    constructor(
        public elementRef: ElementRef,
        @Self() public _menuService: MenuService,
        @SkipSelf() @Optional() public _parentMenuService: MenuService,
        public viewContainerRef: ViewContainerRef
    ) {
        this._menuService.menuItemClicked.subscribe((result) => {
            if (this._parentMenuService)
                this._parentMenuService.menuItemClicked.emit(result);

            this.close();
        });
    }

    ngOnDestroy() {
        this.onClosing.complete();
        this.onOpening.complete();
    }

    ngAfterContentInit() {
        this.items = this._items;
    }

    public open() {
        this.onOpening.next();
    }

    public close() {
        this.onClosing.next();
    }

    public contains(item: MenuItemComponent): boolean {
        if (!item)
            return false;

        return !!this.items.find(x => x === item);
    }
}
